import { AxiosInstance } from "axios";


interface SuburbAutoCompleteEndpoints{
    suburbAutoComplete:string,
    [others: string]: any
}

interface SuburbAutoCompleteConfig{
    axios: AxiosInstance,
    endpoints: SuburbAutoCompleteEndpoints,
    [others: string]: any
}


export default function(config:SuburbAutoCompleteConfig){

    const initialState = {
        axios: config.axios,
        endpoint: config.endpoints.suburbAutoComplete,
    }


    return function(state = initialState, action){

        switch(action.type){
            default: return state
        }

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/suburb-auto-complete/suburb-auto-complete-reducer.ts